/** Shortest password the reset form accepts (Firebase's own floor is 6). */
export const MIN_PASSWORD_LENGTH = 8;

export interface PasswordRules {
    /** At least MIN_PASSWORD_LENGTH characters. */
    longEnough: boolean;
    /** Something was typed, and it is not the account's email address. */
    notEmail: boolean;
    /** The confirmation was typed and is identical to the password. */
    matches: boolean;
}

/**
 * The live rule list under the new-password form. Pure so the form, its
 * submit gate and the tests all read the same answer.
 */
export const checkPasswordRules = (password: string, confirmPassword: string, email: string): PasswordRules => ({
    longEnough: password.length >= MIN_PASSWORD_LENGTH,
    notEmail: password.length > 0 && password.trim().toLowerCase() !== email.trim().toLowerCase(),
    matches: confirmPassword.length > 0 && password === confirmPassword,
});

export const allPasswordRulesMet = (rules: PasswordRules): boolean =>
    rules.longEnough && rules.notEmail && rules.matches;
